import dayjs from "dayjs";

export function isToday(dateString: string) {
    const today = dayjs().format('YYYY-MM-DD');
    const inputDate = dayjs(dateString, 'YYYY-MM-DD').format('YYYY-MM-DD');

    return inputDate === today;
}
